import { render, staticRenderFns } from "./CorporateProfile.vue?vue&type=template&id=0aba144c&"
import script from "./CorporateProfile.vue?vue&type=script&lang=js&"
export * from "./CorporateProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports